import React from 'react';
import { Hero } from '../components/Hero';
import { TopSellers } from '../components/TopSellers';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1777">
      <Hero data-id="element-1778" />
      <TopSellers data-id="element-1779" />
      <WhyUs data-id="element-1780" />
      <Services data-id="element-1781" />
      <HowItWorks data-id="element-1782" />
      <FAQ data-id="element-1783" />
      <Reviews data-id="element-1784" />
      <CtaBanner data-id="element-1785" />
    </main>;
}